import api from '../../api/nodeBackApi';
import { db } from "../../firebase-config";
import { collection, query, where, getDocs } from "firebase/firestore";

export const createCustomer = async (data) => {
    try {
      const response = await api.post('/api/management/customers', data, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      const customerId = data.get("customerId");
  
      for (let i = 0; i < 5; i++) {
        const q = query(
          collection(db, "customers"),
          where("customerId", "==", customerId)
        );
        const snapshot = await getDocs(q);
        if (!snapshot.empty) {
          console.log("Cliente encontrado en Firestore.");
          return response.data; 
        }
        await new Promise(res => setTimeout(res, 500)); // Espera 0.5 seg
      }
  
      console.warn("Cliente creado pero no se encontró aún en Firestore.");
      return response.data;
    } catch (error) {
      console.error("Error al crear el cliente:", error);
      throw error;
    }
  };